import { render, staticRenderFns } from "./ContestList.vue?vue&type=template&id=41cb822f"
import script from "./ContestList.vue?vue&type=script&lang=ts"
export * from "./ContestList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports